import axios from "axios";
import FormData from "form-data";

const baseUrl = process.env.REACT_APP_API;

const getChallengesCategoriesList = () => {
  return axios.get(`${baseUrl}/challenges/categories/`);
};

const getChallengesList = (categoryId,) => {
  return axios.get(`${baseUrl}/challenges/categories/${categoryId}/?size=12`);
};

const getMoreChallengesList = (url) => {
  return axios.get(`${baseUrl}/${url}&size=12`);
};

const addChallengeLike = (categoryId, challengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/like_challenge/`
  );
};

const getChallengeInfo = (categoryId, challengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/`
  );
};

const getKidsChallenges = (categoryId, challengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/`
  );
};

const getMoreKidsChallenges = (url) => {
  return axios.get(`${baseUrl}/${url}`);
};

const addKidsChallengeLike = (categoryId, challengeId, kidChallengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/${kidChallengeId}/like_challenge_answer/`
  );
};

const getOwnerChallenges = (categoryId, challengeId, userId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/get_all_user_answers/?user_id=${userId}`
  );
};

const deleteOwnerChallenges = (categoryId, challengeId, userId, answersArr) => {
  return axios.post(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/delete_answers/`,
    {
      user_id: userId,
      ids: answersArr,
    }
  );
};

const postNewChallengesFile = (categoryId, challengeId, data, file) => {
  const url = `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/`;

  if (data instanceof FormData) {
    return axios.post(url, data);
  }

  const newData = new FormData();

  newData.append("title", data?.challenge_title);

  if (file) {
    newData.append("answer_file", file);
  }

  if (data?.text_answer) {
    newData.append("text_answer", data.text_answer);
  }

  return axios.post(url, newData);
};

const addChallengeView = (categoryId, challengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/watch_challenge_video/?started=True`
  );
};

const addChallengePoint = (categoryId, challengeId) => {
  return axios.get(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/watch_challenge_video/?ended=True`
  );
};

const addChallengeAnswerView = (categoryId, challengeId, data) => {
  return axios.post(
    `${baseUrl}/challenges/categories/${categoryId}/${challengeId}/answers/add_view/`, data
  );
};

const challengesService = {
  getChallengesCategoriesList,
  getChallengesList,
  getMoreChallengesList,
  addChallengeLike,
  getChallengeInfo,
  getKidsChallenges,
  getMoreKidsChallenges,
  addKidsChallengeLike,
  getOwnerChallenges,
  deleteOwnerChallenges,
  postNewChallengesFile,
  addChallengeView,
  addChallengePoint,
  addChallengeAnswerView
};

export default challengesService;
